import { Title } from "@vshp/ui-components";
import pageHero from "../../../public/images/hero.jpg";
import cn from "classnames";
import Image from "next/image";

function Page({ coverImg, title, intro, isWidthSmall = false, children, isExtraBlock = false, extraContent, isWysiwyg = true }) {
  const pageBlockInnerClass = cn({
    wysiwyg: isWysiwyg,
    page__text: isWidthSmall,
    "page__block-body_small": isWidthSmall,
  });

  const bg = coverImg ? coverImg : pageHero;

  return (
    <>
      <div className="page__header">
        <Image className="page__header-cover" src={bg} alt={title} placeholder="blur" />
        <div className="page__header-body page__header-body_center">
          <Title decor={false} className="page__header-title">
            {title}
          </Title>
          {intro && <div className="page__header-intro" dangerouslySetInnerHTML={{ __html: intro }}></div>}
        </div>
      </div>
      <div className="page__blocks">
        <div className={pageBlockInnerClass}>{children}</div>
        {isExtraBlock && <div className="page__block">{extraContent}</div>}
      </div>
    </>
  );
}

export default Page;
